import { useState } from "react";
import { X, ChevronLeft, ChevronRight, Expand } from "lucide-react";
import SectionHeading, { Reveal } from "@/components/SectionHeading";
import { GALLERY } from "@/data/content";

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" data-testid="gallery-section" className="bg-[#0A0A0A] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Gallery"
          title="Inside"
          accent="F12 Fitness"
          subtext="Real photographs from F12 FITNESS Chapters 1 & 2, followed by sample images — more photos coming soon."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {GALLERY.map((g, i) => (
            <Reveal key={g.src} delay={(i % 3) * 0.08}>
              <button
                data-testid={`gallery-item-${i + 1}`}
                onClick={() => setActive(i)}
                className="group relative block w-full overflow-hidden rounded-xl border border-white/10 hover:border-[#FF5A1F]/60 transition-colors"
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  loading="lazy"
                  className="w-full aspect-[4/3] object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-[#0A0A0A]/0 group-hover:bg-[#0A0A0A]/45 transition-colors duration-300 flex items-center justify-center">
                  <Expand className="w-8 h-8 text-[#FF5A1F] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      {active !== null && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
          onClick={(e) => e.target === e.currentTarget && setActive(null)}
        >
          <button
            data-testid="lightbox-close-button"
            onClick={() => setActive(null)}
            className="absolute top-5 right-5 w-10 h-10 rounded-full bg-[#141414] border border-white/20 flex items-center justify-center text-white hover:text-[#FF5A1F] transition-colors"
            aria-label="Close image viewer"
          >
            <X className="w-5 h-5" />
          </button>
          <button
            data-testid="lightbox-prev-button"
            onClick={() => setActive((active - 1 + GALLERY.length) % GALLERY.length)}
            className="absolute left-3 sm:left-6 w-10 h-10 rounded-full bg-[#141414] border border-white/20 flex items-center justify-center text-white hover:text-[#FF5A1F] transition-colors"
            aria-label="Previous image"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <img
            src={GALLERY[active].src}
            alt={GALLERY[active].alt}
            className="max-h-[82vh] max-w-full rounded-xl border border-[#FF5A1F]/40 object-contain"
          />
          <button
            data-testid="lightbox-next-button"
            onClick={() => setActive((active + 1) % GALLERY.length)}
            className="absolute right-3 sm:right-6 w-10 h-10 rounded-full bg-[#141414] border border-white/20 flex items-center justify-center text-white hover:text-[#FF5A1F] transition-colors"
            aria-label="Next image"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      )}
    </section>
  );
}
